import { useMutation } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { toast } from 'sonner';

interface StartScoringResponse {
  message: string;
  pickemId: string;
  totalEntries: number;
}

export async function startScoringAsync(pickemId: string): Promise<StartScoringResponse> {
  const response = await api.post(apiEndpoints.startScoringAsync(pickemId));
  return response.data;
}

export function useStartScoringMutation() {
  return useMutation({
    mutationFn: startScoringAsync,
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.error || 'Failed to start scoring';
      const fullMessage =
        error?.response?.data?.message || error?.response?.data?.current_pickem_id
          ? `${errorMessage}: ${error.response.data.message}`
          : errorMessage;

      toast.error(fullMessage);
    },
  });
}
